import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { FloorEffects } from './floor.effects';
import { floorsReducer } from './floor.reducer';

// ============================================================================
// FLOOR STORE PROVIDER
// ============================================================================
// Note: We will step away from using this provider in the future, so don't
// use this provider or build upon it anymore.
// ============================================================================

export const provideFloorStore = () => [provideState('floors', floorsReducer), provideEffects([FloorEffects])];
